import { initSegmentManager } from '@/segment/integration/segment';

void initSegmentManager();
